import { useState } from "react";
import CardNumber from "../../common/components/CardNumber.jsx";
import Textfield from "../../common/components/Textfiled.jsx";
import { useCountThirdPartyVehiclesQuery } from "./hooks/useCountThirdPartyVehiclesQuery.js";
import { useCountDailyOperatingVehiclesQuery } from "./hooks/useCountDailyOperatingVehiclesQuery.js";
import { useCountVehiclesInspectedDailyQuery } from "./hooks/useCountVehiclesInspectedDailyQuery.js";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import IconButton from "../../common/components/IconButton"
import { BsTruck } from "react-icons/bs";

function Preoperative() {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const { countThirdPartyVehicles } =
    useCountThirdPartyVehiclesQuery(filters);
  const { countDailyOperatingVehicles } =
    useCountDailyOperatingVehiclesQuery(filters);
  const { countVehiclesInspectedDaily } =
    useCountVehiclesInspectedDailyQuery(filters);

  const handleChangeFilters = ({ name, value }) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const goToInspection = () => {
    navigate("/vehiculos-seguros/inspeccion-vehiculos");
  };

  return (
    <main className="container">
       <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Preoperativo</h1>
        <div className="d-flex gap-2">
          <IconButton tooltipText={"Inspección de vehículos"} onClick={goToInspection}>
            <BsTruck size={24} />
          </IconButton>
        </div>
      </header>


      <div className="d-flex justify-content-center justify-content-md-around gap-3 mx-auto">
        <Textfield
          label="Fecha inicio"
          type="date"
          name="startDate"
          value={filters.startDate}
          onChange={handleChangeFilters}
        />
        <Textfield
          label="Fecha fin"
          type="date"
          name="endDate"
          value={filters.endDate}
          onChange={handleChangeFilters}
        />
      </div>

      <section className="d-flex justify-content-center gap-3 justify-content-md-around">
        <CardNumber
          label="Vehículos de terceros usados en el mes"
          number={countThirdPartyVehicles}
        />
        <CardNumber
          label="Vehículos que operan diariamente"
          number={countDailyOperatingVehicles}
        />
      </section>
      <section>
        <div className="d-flex justify-content-center w-75">
          {countVehiclesInspectedDaily.length > 0 ? (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Vehículos inspeccionados</th>
                </tr>
              </thead>
              <tbody>
                {countVehiclesInspectedDaily.map((item) => (
                  <tr key={item.date}>
                    <td>{moment(item.date).format("YYYY/MM/DD")}</td>
                    <td>{item.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>
              No hay datos disponibles para el rango de fechas seleccionado.
            </p>
          )}
        </div>
      </section>
    </main>
  );
}

export default Preoperative;
